import { Container, Row, Col } from "react-bootstrap";
import { Mortarboard, Book, Trophy } from "react-bootstrap-icons";
import "animate.css";
import TrackVisibility from "react-on-screen";
import "./Education.css";

export const Education = () => {
  const educationList = [
    {
      degree: "B.Tech in Computer Science and Engineering",
      institution: "Lovely professional university -jalandhar punjab",
      date: "2023 - 2027",
      description: "Focusing on Software Development, Data Structures & Algorithms, and modern web technologies. Building scalable full-stack applications.",
      icon: <Mortarboard className="timeline-icon-svg" />
    },
    {
      degree: "Higher Secondary (Class XII)",
      institution: "Veena Vidya Niketan Senior Secondary School, Patna",
      date: "2021 - 2023",
      description: "Studied Physics, Chemistry, and Mathematics. Developed strong analytical and problem-solving skills.",
      icon: <Book className="timeline-icon-svg" />
    },
    {
      degree: "Secondary (Class X)",
      institution: "Lakshaya International Academy- hajipur, Bihar ",
      date: "2020 - 2021",
      description: "Foundation in science and mathematics. Participated in various academic and extracurricular activities.",
      icon: <Trophy className="timeline-icon-svg" />
    }
  ];

  return (
    <section className="education" id="education">
      <Container>
        <Row>
          <Col size={12}>
            <TrackVisibility>
              {({ isVisible }) => (
                <div className={isVisible ? "animate__animated animate__fadeIn" : ""}>
                  <div className="text-center mb-5">
                    <h2>Education</h2>
                    <p className="education-subtitle">My Academic Journey</p>
                  </div>
                  
                  <div className="timeline-container">
                    {educationList.map((item, index) => (
                      <div 
                        key={index} 
                        className={`timeline-item ${isVisible ? 'animate__animated animate__zoomIn' : ''}`}
                        style={{ animationDelay: `${index * 0.2}s` }}
                      >
                        <div className="timeline-icon">
                          {item.icon}
                        </div>
                        <div className="timeline-content">
                          <h4 className="timeline-degree">{item.degree}</h4>
                          <h5 className="timeline-institution">{item.institution}</h5>
                          <div className="timeline-date">{item.date}</div>
                          <p className="timeline-description">{item.description}</p>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>
    </section>
  );
};
